export default class ProxiedClass {
  /** @type {String} */
  name = null;

  /** @type {WorkerProxy} */
  proxy = null;

  /**
   * Instantiates a proxied class.
   *
   * @param {WorkerProxy} workerProxy
   * @param {String} className
   * @param {String[]} methods
   */
  constructor(workerProxy, className, methods) {
    this.proxy = workerProxy;
    this.name = className;
    methods.forEach((method) => {
      this[method] = this.callMethod.bind(this, method);
    });
  }

  /**
   * Calls the class method via the WorkerProxy.
   *
   * @param {String} method
   */
  callMethod(method, payload) {
    return this.proxy.callMethod(`CLASS_METHOD_CALL_${this.name}`, method, payload);
  }

  /**
   * Subscribes to a given subscription ID using the given callback.
   *
   * @param {String} id
   * @param {Function} callback
   */
  subscribe(id, callback) {
    this.proxy.subscribe(`${this.name}/${id}`, ({ payload }) => {
      callback(payload);
    });
  }
}
